import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-card-value-pair-ext',
  standalone: true,
  imports: [Skeleton, CommonModule],
  templateUrl: './card-value-pair-ext.component.html',
  styleUrl: './card-value-pair-ext.component.css',
})
export class CardValuePairExtComponent {
  @Input({ required: true }) isLoading: boolean = false;
  @Input({ required: true }) title!: string;
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) value!: string;
  @Input({ required: true }) borderBottomColor!: string;
  @Input({ required: true }) title2!: string;
  @Input({ required: true }) icon2!: string;
  @Input({ required: true }) value2!: string;
  @Input() tooltip1: string = '';
  @Input() tooltip2: string = '';
}
